export * from './highlight.pipe';


// WEBPACK FOOTER //
// ./src/app/shared/pipes/index.ts